export const DATA_LAYER_EVENT = {
  COMPLETE_ALL_STEPS: "profile-input-flow_complete-all-steps",
  ENTRY_FIRST_STEP: "profile-input-flow_entry-first-step",
  SAVE_IMAGE: "profile-input-flow_save-profile-img",
  SAVE_ACTIVITY: "profile-input-flow_save-application-categories",
  SAVE_INTEREST: "profile-input-flow_save-job-hunting-interest",
  SAVE_SELECTION: "profile-input-flow_save-company-selections",
  SAVE_APPEAL: "profile-input-flow_save-self-appeals",
  SAVE_EXPERIENCE: "profile-input-flow_save-experiences",
  COMPLETE_NEW_REGISTRATION: "complete-new-registration",
  COMPLETE_NEW_REGISTRATION_ADDITIONALLY: "complete-new-registration-additionally",
  OPEN_LTI_SCOUT: "open-lti-scout",
} as const
